//import "./safetyforms.css";
import moment from 'moment';
import { useContext } from "react";
import "react-dropdown/style.css";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { ErrorContext } from "../ErrorContext";
import { Attribute, Container } from "./Attribute";
import { BlackButton, ButtonBase } from "./Buttons";
import Row from "./Row";
import Sidebar from "./Sidebar";
import { H1, P2, P3 } from "./Typography";
import useFileMeta from "./useFileMeta";

const SidebarMedia = ({ media }) => {
    const errorContext = useContext(ErrorContext);
    const nav = useNavigate();
    const dispatch = useDispatch();
    const meta = useFileMeta(media?.filename);

    const onClickReport = () => {
        window.open(`/daily-report/${media?.dailyReportId}`, '_blank')
    }

    return (
        <Sidebar>
            <Row>
                <H1 style={{ flex: 1 }}>Media Preview</H1>
                <ButtonBase style={{ padding: "0.5rem" }} onClick={() => nav("/images")}>
                    <FaTimes size={"14px"} color="#000" />
                </ButtonBase>
            </Row>
            <Container>
                <P3>Media Information</P3>
                <Attribute>
                    <P2>Created By</P2>
                    {`${media?.user?.firstName} ${media?.user?.lastName}`}
                </Attribute>
                <Attribute>
                    <P2>Created At</P2>
                    {moment(media?.createdAt).format("YYYY-MM-DD [at] h:mm a")}
                </Attribute>
                <Attribute>
                    <P2>Filesize</P2>
                    {meta?.fileSize}
                </Attribute>
                {
                    media?.description &&
                    <Attribute>
                        <P2>Notes</P2>
                        {media?.description}
                    </Attribute>
                }
                {
                    media?.dailyReport &&
                    <BlackButton onClick={onClickReport}>View Associated Report</BlackButton>
                }
            </Container>
        </Sidebar>
    )
}

export default SidebarMedia;